import { t } from '@gem/modules/i18n';
import { media } from '@gem/modules/permissions';

import Tasks from 'APP/Tasks';
import deviceInfo from 'APP/packages/deviceInfo';

export default async () => {
  const { hasMicrophone } = await deviceInfo.getMediaDevices();

  if (!hasMicrophone) {
    Tasks.app.showAlert(t('calls_no_microphone_connected'));

    return false;
  }

  const hasAudioPermission = await media.getAudioPermission();

  if (!hasAudioPermission) {
    Tasks.app.showAlert(t('calls_no_microphone_permissions'));

    return false;
  }

  return true;
};
